import React from "react";
import clsx from "clsx";

import Button from "@material-ui/core/Button";
import useStyles from "./styles";

interface Props {
  value?: string;
  onClearSearch?: () => void;
  showClearSearchButton?: boolean;
  className?: string;
}

const SearchNoResults = (props: Props) => {
  const {
    value,
    onClearSearch,
    className,
    showClearSearchButton = true
  } = props;

  const classes = useStyles();

  const handleResetSearch = () => {
    if (onClearSearch) {
      onClearSearch();
    }
  };

  return (
    <section className={clsx(classes.emptyResult, className)}>
      <div
        className={clsx(classes.emptyResultText, {
          [classes.textSearch]: !!className
        })}
      >
        {value?.length ? `No Results for "${value}"` : "No Results"}
      </div>
      {value && showClearSearchButton && (
        <Button
          onClick={handleResetSearch}
          variant="outlined"
          className={classes.clearSearch}
        >
          Clear search
        </Button>
      )}
    </section>
  );
};

export default React.memo(SearchNoResults);
